export const HttpStatusCode = {
    Unauthorized: 401,
    Forbidden: 403,
    InternalServerError: 500
  };
 